import * as $ from "jquery";
import "jquery.qtip";

function closeMessage(e: Event) {
	$(e.currentTarget).closest(".page-message").remove();
}

export function addMessage(severity: Severity, message: string, closeAfter = 0) {
	let messageHTML = `
		<div class="page-message page-message-${severity}">
			${message}
			<button class="close">×</button>
		</div>
		`;

	let $messageContainer = $(".page-message-container");
	let currentMessageHTML = $messageContainer.html();
	$messageContainer.html(currentMessageHTML + messageHTML);
	$messageContainer.children(".page-message").each(function(this: HTMLElement) {
		let $this = $(this);
		if (closeAfter > 0) {
			$this.delay(closeAfter).queue(function() {
				$this.fadeOut().remove();
				$this.dequeue();
			});
		}
	});
}

export function clearMessages() {
	$(".page-message-container").empty();
}


// Handle message tooltips
$(function() {
	$(".message-tooltip").each(function(this: HTMLElement) {
		let $icon = $(this);
		let $content = $icon.children(".content");
		($(this) as any).qtip({
			content: {
				text: $content,
			},
			show: {
				event: "mouseenter click",
			},
			hide: {
				event: "unfocus mouseleave",
				fixed: true,
				delay: 300,
			},
			style: {
				tip: {
					corner: false,
				},
			},
		});
	});
});


// Use delegation to handle any elements generated after the current point
$(document).on("click", ".page-message .close", closeMessage);


export type Severity = "success" | "warning" | "alert" | "info";

// tslint:disable-next-line:variable-name
export const Severity = {
	Success: "success",
	Warning: "warning",
	Alert: "alert",
	Info: "info",
};
